export default {
  refund: '退款',
  refund_instructions: '退款说明',
  customer_order_no: '客户订单号',
  transaction_type: '交易类型',
  merchant_order_id: '商户订单号',
  create_time: '创建时间',
  creator: '创建人',
  transaction_amount: '交易金额',
  transaction_status: '交易状态',
  fee: '费用',
  institute_id: '渠道ID',
  merchant_name: '商家名称',
  product_name: '产品名称',
  refundable_amount: '可退还金额',
  payment_details: '交易详情',
  payout_details: '代付明细',
  payment: '收款',
  payout: '付款',
  payment_serial_number: '支付流水号',
  stream_creation_time: '流水创建时间',
  organization_return_order_time: '机构返回订单时间',
  retry_payment: '尝试重新支付',
  mobile: '手机号',
  customer_phone_number: '客户手机号',
  account_no: '还款码',
  bill_account_no: '还款码',
  account_number: '还款码',
  qr_link: '二维码链接',
  qr_download: '下载链接',
  qr_code_id: '二维码ID',
  work_order_number: '工单号',
  institution_type: '渠道类型',
  business_type: '业务类型',
  transaction_id: '交易编号',
  reference_no: '单据号',
  void_transaction_id: '撤销交易编号',
  void_complete_time: '撤销完成时间',
  issue: '问题',
  conclusion: '结论',
  replies: '回复',
  reply: '回复',
  reopen: '重新打开',
  cs_intervention_time: '客服介入时间',
  cs_completion_time: '客服完成时间',
  image: '照片',
  add_work_order: '新建工单',
  payment_code: '还款码',
  app_name: '应用名称',
  payer_mobile: '还款人手机号',
  remitting_bank: '付款银行',
  remittance_account: '付款账号',
  payment_method: '支付方式',
  description: '描述',
  transaction_history: '付款凭证',
  payment_receipt: '付款凭证',
  attachments: '附件',
  reference: '批次号',
  submit_quantity: '提交数量',
  success_quantity: '成功',
  pending_quantity: '处理中',
  fail_quantity: '失败',
  total_amount: '总金额',
  validation: '校验',
  single_payment_link: '创建单个链接',
  batch_payment_link: '批量创建链接',
  payment_channel: '支付渠道',
  email_content: '邮件内容',
  beneficiary_mobile: '收款人手机号',
  email_address: '收款人邮箱',
  customer_name: '客户名称',
  download_template: '下载模板',
  upload_file_template: '上传填写完成的模板',
  edit_collection: '编辑链接',
  payin_search: '收款查询',
  payout_search: '付款查询',
  card_verification_search: '验卡查询',
  other_details: '其他详情',
  ticket_details: '工单详情',
  re_open_ticket: '重启工单',
  ph_invoice_no: 'PH Invoice No.',
  qrph_invoice_no: 'QRPH Invoice No.',
  invoice_no: '单据号',
  wayBill_num: '运单号',
  wayBill_status: '运单状态',
  refund_status: '退款状态',
  refund_type: '退款类型',
  refund_search: '退款查询',
  original_transaction_id: '原交易编号',
  refund_transaction_id: '退款交易编号',
  original_transaction_amount: '原交易金额',
  refund_amount_already: '已退款金额',
  present_refund_amount: '本次退款金额',
  refund_order_amount: '退款订单金额',
  refund_fee: '退款手续费',
  refund_failed_fee: '退款手续费 (退款失败)',
  amount_to_receive: '到账金额',
  refund_fee_charge_mode: '退款手续费承担模式',
  refund_reason: '退款原因',
  cumulative_amount_refunded: '累计已退订单金额',
  remaining_refundable_order_amount: '剩余可退订单金额',
  original_transaction_fee_charge_mode: '原交易手续费承担模式',
  total_refunded_amount: '已退款总金额',
  refund_transaction_details: '退款交易明细',
  refund_commission_amount: '退款退佣金金额',
  refund_commission_amount_summary: '退款退佣金金额汇总',
  refund_commission_amount_number: '退款退佣金金额笔数',
  refund_transactions_number: '退款交易笔数',
  refund_channel_refund_fee_amount: '退款渠道退手续费金额',
  refunds_summary: '退款笔数汇总',
  full_refund_summary: '退款交易金额汇总',
  return_fee_summary: '退回手续费汇总',
  total_refund_fee: '退款手续费汇总',
  refunded_transaction_fee: '退回手续费金额',
  actual_refund_amount_received: '退款发起方到账金额',
  refund_transaction_amount: '退款交易金额',
  transaction_fee_change_mode: '手续费承担方',
  refund_order_status: '退款订单状态',
  full_refund: '全额退款',
  partial_refund: '部分退款',
  request_refund_amount: '申请退款金额',
  refund_transaction_status: '退款交易状态',
  refund_transactions_number_summary: '退款交易笔数汇总',
  remaining_refundable_amount: '剩余可退款金额',
  process_refund_transactions: '处理退款交易',
  process_refund_details: '处理退款详情',
  handle_time: '处理时间',
  mch_refund_order_id: '商户退款订单号',
  bill_no: '账单编号',
  bill: '账单',
  loan_type: '借款类型',
  customer_no: '客户编号',
  beneficiary_account: '收款账号',
  loan_channel: '放款通道',
  asset_belonged: '资产方',
  funding_parties: '资金方',
  credit_type: '信贷类型',
  loan_amount: '借款金额',
  credit_service: '信贷服务',
  repay_method: '还款方式',
  repayment_amount: '还款金额',
  current_fx: '汇率',
  down_payment_amount: '首付金额',
  installment_amount: '分期金额',
  payment_order_number: '支付单号',
  loan_status: '借款状态',
  collection_channel_type: '收款渠道类型',
  account: '账号',
  payee_type: '收款人类型',
  payee_id_number: '收款人证件号',
  payee_relationship: '收款人关系',
  payee_phone_number: '收款人手机号',
  bill_amount: '账单金额',
  principal_repayment_amount: '本金',
  penalty_repayment_amount: '罚金',
  interest: '利息',
  installment_term: '期数',
  due_date: '还款日',
  loan_transaction_no: '交易编号',
  repay_transaction_no: '交易编号',
  transaction_id_wallet: '支付单号',
  amount: '借款金额',
  installment_amount_wallet: '贷款金额',
  status: '交易状态',
  jt_issuer_name: '支付方式',
  aggregate_cod_Amount: 'Cod总金额',
  aggregate_cod_fee_amount: 'Cod总手续费',
  aggregate_frt_amount: '运费总金额',
  aggregate_frt_fee_amount: '运费总手续费',
  transaction_fee_charge_mode: '手续费承担模式',
  charge_to_merchants: '商户承担',
  charge_to_customer: '用户承担',
  payment_type: '支付类型',
  paid_account_no_suffix: '付款账户后缀',
  billing_address: '账单地址',
  qr_stand_id: '二维码立牌ID',
  amount_refunded_successfully: '已退款成功金额',
  pay_card_no: '卡号',
  pay_card_scheme: '卡组',
  pay_card_issuer: '发卡行'
}
